import { ConnectorPropertyColumn } from "@/enums/tables/connectorPropertyColumn.enum";
import { PropertyColumn } from "@/enums/tables/propertyColumn.enum";

export const tablesEnvironment = {
  property: {
    condo: {
      lightColumns: [
        PropertyColumn.SELECT,
        PropertyColumn.CERTIF,
        PropertyColumn.PHOTO,
        PropertyColumn.NAME,
        PropertyColumn.TYPE,
        PropertyColumn.NUM,
        PropertyColumn.FLOOR,
        PropertyColumn.CHILDREN,
        PropertyColumn.ACTIONS,
      ],
      fullColumns: [
        PropertyColumn.SELECT,
        PropertyColumn.CERTIF,
        PropertyColumn.PHOTO,
        PropertyColumn.NAME,
        PropertyColumn.TYPE,
        PropertyColumn.OWNER_NAME,
        PropertyColumn.NUM,
        PropertyColumn.FLOOR,
        PropertyColumn.CERTIFICATION,
        PropertyColumn.EEMO_ID,
        PropertyColumn.CHILDREN,
        PropertyColumn.ACTIONS,
      ],
    },
    home: {
      lightColumns: [
        PropertyColumn.SELECT,
        PropertyColumn.CERTIF,
        PropertyColumn.PHOTO,
        PropertyColumn.NAME,
        PropertyColumn.TYPE,
        PropertyColumn.CITY,
        PropertyColumn.SELLING_PRICE,
        PropertyColumn.DATE_CREATE,
        PropertyColumn.ACTIONS,
      ],
    },
  },
  connectorProperty: {
    lightColumns: [
      ConnectorPropertyColumn.PHOTO,
      ConnectorPropertyColumn.TYPE,
      ConnectorPropertyColumn.NAME,
      ConnectorPropertyColumn.ADDRESS,
      ConnectorPropertyColumn.STATUS,
      ConnectorPropertyColumn.ACTIONS,
    ],
  },
};
